<div style="position: relative; z-index: 10;" id="showplanoptions-modal" aria-labelledby="modal-title" role="dialog"
  aria-modal="true">
  <div style="position: fixed; inset: 0; background-color: rgba(107, 114, 128, 0.75);" aria-hidden="true"></div>

  <div style="position: fixed; inset: 0; z-index: 10; width: 100vw; overflow-y: auto;">
    <div
      style="display: flex; min-height: 100%; align-items: flex-end; justify-content: center; padding: 1rem; text-align: center;">
      <!-- Modal panel -->
      <div
        style="position: relative; overflow: hidden; border-radius: 0.5rem; background-color: white; text-align: center; margin-left: auto; margin-right: auto; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); margin-top: 2rem; margin-bottom: 2rem; width: 100%; max-width: 80rem;">

        <div style="background-color: white;">
          <!-- Header -->
          <div
            style="display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 1.5rem; height: 4rem; border: 1px solid; border-bottom-color: #4338ca; background-color: #00297A; color: white;">
            {{lang.Choose_Options}}
          </div>

          <!-- Content -->
          <div
            style="margin-top: 0.75rem; margin-left: 1rem; margin-right: 1rem; text-align: left; max-height: calc(100vh - 200px); overflow-y: auto;">

            <input type="hidden" id="plandetailsobj" #optionPlanDetailsObj value="{{plandetailsobjvalue}}">
            <input type="hidden" id="optionumber" #optionNumberInput value="{{optionstitle.length}}">

            @for(option of optionstitle; track option; let i = $index){
            @if(i == optionstitle.length-1){
            <div style="width: 98%;">
              <h3><b>{{option.name}}</b><span style="color: red">*</span></h3>

              @for(optionvalue of option.planOptionsValues; track optionvalue; let j = $index){
              <div class="row">
                <div class="col-md-12" style="padding: 5px 15px; border-bottom: 1px solid black;">
                  <input type="radio" value="{{optionvalue.json}}"
                    id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" #optionUnseelct
                    class="optionselectionmethod-{{option.id}}"
                    (change)="planoptionselection($event, optionvalue, option.id, optionvalue.id, i, 'optionselectionmethod-')">
                  &nbsp;{{optionvalue.name}}
                </div>
              </div>
              }
              <br>
            </div>
            } @else {
            <div style="margin-bottom: 1.5rem;">
              <h3 style="margin-bottom: 1rem;"><b>{{option.name}}</b><span style="color: red;">*</span></h3>

              <!-- Table-like layout with province and clinics -->
              <div style="display:flex;gap: 2px;border-radius: 50%;">
                <div
                  style="background-color: #606f8e;width: 70%;height: 50px;/* margin: auto; */display: flex;align-items: center;justify-content: center;font-size: 16px;color: white;">
                  Clinic
                </div>
                <div
                  style="background-color: #606f8e;width: 30%;height: 50px;display: flex; align-items: center; justify-content: center; font-size: 16px; color: white;">
                  Location
                </div>
              </div>
              <div style="border: 1px solid black;">
                @for(province of getGroupedByProvince(option.planOptionsValues); track province.provinceId; let isFirst
                = $first){
                @if(!isFirst){
                <div style="border-top: 2px solid black;"></div>
                }

                <div style="display: grid; grid-template-columns: 150px 1fr;">
                  <!-- Province Name Column (spans all rows) -->
                  <div
                    style="display: flex; align-items: center; justify-content: center; font-weight: bold; border-right: 1px solid black; padding: 10px; text-align: center; background-color: #f8f9fa;">
                    {{province.provinceName}}
                  </div>

                  <!-- Clinics Column -->
                  <div>
                    @for(optionvalue of province.clinics; track optionvalue; let j = $index; let isLast = $last){
                    <div style="padding: 8px 15px; display: flex; align-items: center; justify-content: space-between;"
                      [style.border-bottom]="!isLast ? '1px solid #ddd' : 'none'">
                      <div [style.height]="optionvalue.name.includes('(') ? '39px !important' : '27px !important'">
                        <div style="display: flex; align-items: center; gap: 5px; margin-top: 10px;">
                          <input type="radio" value="{{optionvalue.json}}"
                            id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" #optionUnseelct
                            class="optionselectionmethod-{{option.id}}"
                            (change)="planoptionselection($event, optionvalue, option.id, optionvalue.id, i, 'optionselectionmethod-')">
                          <p style="margin-top: -4px !important;">{{ optionvalue.name.includes('(')
                            ? optionvalue.name.split('(')[0]
                            : optionvalue.name }}
                            &nbsp;</p>
                        </div><br />

                        <p style="font-size: 9px; margin-top: -18px !important;" *ngIf="optionvalue.name.includes('(')">
                          ({{ optionvalue.name.split('(')[1] }}
                        </p>
                      </div>
                      <div style="margin-right: 15px;">
                        {{optionvalue.location}}
                        <span *ngIf="optionvalue.address" style="display: inline-block;"
                          title="{{optionvalue.address}}">
                          <svg version="1.0" style="width: 10px;" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64"
                            enable-background="new 0 0 64 64" xml:space="preserve" fill="#000000">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                              <g>
                                <path fill="#231F20"
                                  d="M32,0C18.745,0,8,10.745,8,24c0,5.678,2.502,10.671,5.271,15l17.097,24.156C30.743,63.686,31.352,64,32,64 s1.257-0.314,1.632-0.844L50.729,39C53.375,35.438,56,29.678,56,24C56,10.745,45.255,0,32,0z M32,38c-7.732,0-14-6.268-14-14 s6.268-14,14-14s14,6.268,14,14S39.732,38,32,38z">
                                </path>
                                <path fill="#231F20"
                                  d="M32,12c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S38.627,12,32,12z M32,34 c-5.523,0-10-4.478-10-10s4.477-10,10-10s10,4.478,10,10S37.523,34,32,34z">
                                </path>
                              </g>
                            </g>
                          </svg>
                        </span>
                      </div>

                    </div>
                    }
                  </div>
                </div>
                }
              </div>
            </div>
            }
            }

          </div>
        </div>

        <div id="planoptionmessage" class="invalid text-red-500" style="padding: 0.5rem 1rem; color: #ef4444;">
          <b>{{optionmessage}}</b>
        </div>

        <div
          style="background-color: #f9fafb; padding: 0.75rem 1rem; display: flex; flex-direction: row-reverse; gap: 0.5rem; border: 1px solid; border-top-color: #4338ca;">

          <button type="button"
            style="width: 9rem; height: 3.5rem; margin-bottom: 0.25rem; border-radius: 9999px; border: 2px solid #c7d2fe; background-color: #c7d2fe; padding: 0.125rem; cursor: pointer; font-weight: 600;"
            (click)="closeoptionsselection()">
            {{lang.Close}}
          </button>

          <button type="button"
            style="width: 9rem; height: 3.5rem; margin-bottom: 0.25rem; border-radius: 9999px; border: 2px solid #bbf7d0; background-color: #c7d2fe; padding: 0.125rem; cursor: pointer; font-weight: 600;"
            (click)="confirmoptionsselection()">
            {{lang.Confirm}}
          </button>

        </div>

      </div>
    </div>
  </div>
</div>

<!-- CSS for responsive and hover effects that can't be done inline -->
<style>
  /* Responsive grid for larger screens */
  @media (min-width: 768px) {
    .province-grid-container {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }

  /* Hover effect for clinic rows */
  .clinic-row:hover {
    background-color: #f9fafb;
  }

  /* Button hover effects */
  button[type="button"]:hover {
    background-color: white;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  /* Radio button styling */
  input[type="radio"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
</style>
